// Import project modules
import { qS, isAdmin } from './_default.js';
import { translations } from './translations.js';

const notifications = {
  STAY_FOR_MS: 4000,
  active: false,
  init: async function() {
    // Activate
    notifications.active = true;

    // Notifications
    qS('body').insertAdjacentHTML('beforeend', '<div id="notifications_container" class="notification-container"></div>');

    // Info
    qS('body').insertAdjacentHTML('afterbegin', '<div id="info_container" class="info-container"></div>');

    // Check for URL parameters
    notifications.checkForURLParamater();
  },

  showSuccess: function(message){
    if(!message){
      message = translations.getString('app.save_success');
    }
    notifications.show(message, 'success', '#notifications_container');
    notifications.easterEgg();
  },

  showError: function(message){
    if(!message){
      message = translations.getString('app.unknown_error');
    }
    notifications.show(message, 'error', '#notifications_container', true);
  },

  remove: function(element){
    // Element could have been removed before
    try {
      if(element.parentElement.innerHTML === ''){
        element.parentElement.style.display = 'none';
      }
      element.remove();
    } catch (error) {
      console.log('Element no longer exists');
    }
  },

  show: function(message, type, target, stay) { 
    if(!notifications.active){return;}
    const targetElement = qS(target);
    const div = document.createElement('div');
    div.classList.add(`notification`);
    if(type){
      div.classList.add(`info-${type}`);
    }
    if(stay){
      div.classList.add(`notification-stay`);
    }

    // Create the inner text div
    const textDiv = document.createElement('div');
    textDiv.classList.add('text');
    textDiv.textContent = message;
    
    // Create the close button div
    const closeDiv = document.createElement('div');
    closeDiv.classList.add('close');
    
    // Add an event listener to remove the parent div when close is clicked
    closeDiv.addEventListener('click', () => {
      notifications.remove(div);
    });
    
    // Append textDiv and closeDiv to the main div
    div.appendChild(textDiv);
    div.appendChild(closeDiv);
    
    targetElement.appendChild(div);
    targetElement.style.display = 'block';

    if(!stay){
      setTimeout(() => {
        notifications.remove(div);
      }, notifications.STAY_FOR_MS);
    }
  },

  easterEgg: function(){
    if(!notifications.active){return;}
    if(!isAdmin){return;} // Only for pages /admin
    if(Math.random() > .01){return;} // 1% chance

    const easterEggDiv = document.createElement('div');
    easterEggDiv.classList.add('easter-egg');
    document.body.appendChild(easterEggDiv);

    setTimeout(() => {
      easterEggDiv.remove();
    }, 5000);
  },

  checkForURLParamater: function(){
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const info = params.has('info') ? decodeURIComponent(params.get('info')) : null;
    if(info){
      notifications.show(info, params.get(`info_type`) || null, '#info_container', true);
    }
    const notification = params.has('notification') ? decodeURIComponent(params.get('notification')) : null;
    if(notification){
      notifications.show(notification, params.get(`notification_type`) || null, '#notifications_container');
    }

    // Remove URL parameters
    ['info', 'notification', 'info_type', 'notification_type'].forEach(param => params.delete(param));
    const newUrl = params.toString() ? `${url.pathname}?${params.toString()}` : url.pathname;
    window.history.replaceState({}, document.title, newUrl);   
  } 
}

// For all modules available
window.notifications = notifications;

export { notifications };